import { MarginContainer } from "@/components/layout/MarginContainer";
import { type Opportunity } from "@repo/api";
import { Text } from "@repo/skapa";
import { Icon, mailIcon, phoneIcon } from "@repo/skapa";
import { T, t } from "@repo/translation";
import {
  FlexDiv,
  LabelField,
  Name,
  SectionContainer,
  TwoColumnSectionContainer,
  getCustomerLanguage,
  translateLanguage,
  useCustomer,
} from "@repo/ui";

interface CustomerProps {
  opportunity: Opportunity;
}
export const Customer = ({ opportunity }: CustomerProps) => {
  const { customer } = useCustomer(opportunity.id);

  if (!customer) {
    return (
      <SectionContainer>
        <Text>
          <T translationKey="prompt.no_customer_info" />
        </Text>
      </SectionContainer>
    );
  }
  const isBusinessCustomer = customer?.customerType === "Business";

  return (
    <SectionContainer>
      <TwoColumnSectionContainer>
        <LabelField
          id="customer-modal-name"
          label={t("label.name")}
          value={
            <Name firstName={customer.firstName} lastName={customer.lastName} />
          }
        />
        <LabelField
          id="customer-modal-customer-type"
          label={t("label.customer_type")}
          value={customer.customerType}
        />
        <LabelField
          id="customer-modal-address"
          label={t("label.address")}
          value={
            <div>
              <Text>{customer.streetAddress1}</Text>
              {customer.streetAddress2 && (
                <Text>{customer.streetAddress2}</Text>
              )}
              {customer.streetAddress3 && (
                <Text>{customer.streetAddress3}</Text>
              )}
              <Text>
                {customer.postalCode} {customer.city}
              </Text>
              <Text>{customer.country}</Text>
            </div>
          }
        />
        {isBusinessCustomer && (
          <LabelField
            id="customer-modal-company-name"
            label={t("label.company_name")}
            value={customer.organizationName}
          />
        )}
        <LabelField
          id="customer-modal-contact"
          label={t("label.contact")}
          value={
            <div>
              <FlexDiv>
                <MarginContainer>
                  <Icon paths={mailIcon} />
                </MarginContainer>
                <Text wordBreakWord>{customer.email}</Text>
              </FlexDiv>
              <FlexDiv>
                <MarginContainer>
                  <Icon paths={phoneIcon} />
                </MarginContainer>
                <Text>{customer.phoneNumber}</Text>
              </FlexDiv>
            </div>
          }
        />
        <LabelField
          id="familyNumber"
          label={t("label.family_number")}
          value={customer.familyNumber}
        />
        <LabelField
          id="contactMethod"
          label={t("label.preferred_contact_method")}
          value={
            customer.preferredContactType === "PHONE"
              ? t("label.phone")
              : t("label.email")
          }
        />
        <LabelField
          id="language"
          label={t("label.preferred_language")}
          value={
            customer.language
              ? translateLanguage(getCustomerLanguage(customer.language))
              : ""
          }
        />
      </TwoColumnSectionContainer>
    </SectionContainer>
  );
};
